/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
	BoldText,
	Container,
	DemoPage,
	DemoPageContent,
	FormSection,
	UnderlinedText,
} from 'Data/Form/Components/Components.styles';
import LoadingSpinner from 'Settings/components/LoadingSpinner/LoadingSpinner';
import {
	getAliasAccordingToEnv,
	getSurveyForm,
	saveOrUpdateSurveyForm,
} from 'utils/apiRequests';
import NoAliasAssigned from 'Data/Form/Components/NoAliasAssigned/NoAliasAssigned';
import Navigation from './Components/Navigation';
import IntroSection from './Components/IntroSection';
import TextInput from './Components/TextInput';
import RadioInput from './Components/RadioInput';
import {
	AREAS_COVERED_IN_PROJECT,
	AI_OPTIONS,
	CLM_TOOL_OPTIONS,
	countFilledFields,
	DEFAULT_FORM,
	INDUSTRY_OPTIONS,
	NATURE_OF_ENGAGEMENT_OPTIONS,
	PROCUREMENT_OPTIONS,
	PROCUREMENT_STRUTURE_OPTIONS,
	PTP_TOOL_OPTIONS,
	REGION_OPTIONS,
	SPEND_ANALYTICS_TOOL_OPTIONS,
	RESPONSIBILITIES_PROCUREMENT_OWN,
} from './../utils';
import NumberInput from './Components/NumberInput';
import CheckboxInput from './Components/CheckboxInput';
import { ApButtonMain, ApButtonSecondary } from '@alixpartners/ui-components';
import Toast from 'components/Toast/Toast';
import { NotificationTypes } from 'components/Toast/constants';
import SliderInput from './Components/SliderInput';
import DropdownInput from './Components/DropdownInput';
import YearPicker from './Components/YearPicker';
const toastTime = 15000;
function Form() {
	const [aliasList, setAliasList] = useState([]);
	const [selectedAlias, setSelectedAlias] = useState(null);
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState(DEFAULT_FORM);
	const [toasts, setToasts] = useState([]);

	const inputsWithOtherTextfields = [
		'industry',
		'procurementFunction',
		'procurementStructure',
		'ptpTool',
		'clmTool',
		'spendAnalyticsTool',
	];

	useEffect(() => {
		getCurrentDataForSurveyForm();
	}, []);
	useEffect(
		() => {
			if (selectedAlias !== null) {
				getCurrentAliasFormData();
			}
		},
		[selectedAlias]
	);
	const getCurrentAliasFormData = async () => {
		const responseData = await getSurveyForm({
			alias_name: selectedAlias.value,
		});
		if (
			responseData.data.data !== null &&
			responseData.data.data.length !== 0
		) {
			setFormData(JSON.parse(responseData.data.data));
		} else {
			setFormData(DEFAULT_FORM);
		}
	};
	const getCurrentDataForSurveyForm = async () => {
		setLoading(true);
		const responseForAlias = await getAliasAccordingToEnv();
		if (
			responseForAlias.errors.Length !== 0 &&
			responseForAlias.data !== null
		) {
			const aliasOptionsFormatted = responseForAlias.data.map(data => ({
				label: data,
				value: data,
			}));
			setAliasList(aliasOptionsFormatted);
			setSelectedAlias(aliasOptionsFormatted[0] || null);
		} else {
			console.log('Error Occured');
		}

		setLoading(false);
	};

	const handleChange = e => {
		const {
			name,
			type,
			value,
			checked,
			isNumber,
			showPercentage,
			selectedOption,
		} = e.target;

		setFormData(prevFormData => {
			if (type === 'checkbox') {
				// Handle checkboxes (multiple selections)
				let newValues;
				if (showPercentage) {
					newValues = checked
						? prevFormData[name]
							? [...prevFormData[name], { [value]: '' }]
							: [{ [value]: '' }] // Add value if checked
						: prevFormData[name].filter(v => !v.hasOwnProperty(value)); // Remove value if unchecked
					validateTotalPercantage(newValues);
				} else {
					newValues = checked
						? prevFormData[name]
							? [...prevFormData[name], value]
							: [value] // Add value if checked
						: prevFormData[name].filter(v => v !== value); // Remove value if unchecked
				}

				return {
					...prevFormData,
					[name]: newValues,
				};
			} else if (type === 'radio') {
				return {
					...prevFormData,
					[name]: [checked ? value : ''],
				};
			} else if (type === 'select-one') {
				return {
					...prevFormData,
					[name]: [value],
				};
			} else {
				// Handle other input types (text, number, date, etc.)
				if (isNumber) {
					//handle textinput with numbers, allow only numbers or "NA" value

					if (showPercentage) {
						let newValues = [...prevFormData[name]];
						let index = newValues.findIndex(item =>
							item.hasOwnProperty(selectedOption)
						);
						newValues[index][selectedOption] = !isNaN(value) // Check if the value is a number.
							? value // If it's a number, keep the value.
							: !isNaN(value.charAt(value.length - 2)) && value.length >= 2 // Check if the second-to-last character is a number and the length is at least 2.
								? prevFormData[name][index][selectedOption] // If true, retain the previous value.
								: value === 'N' // Check if the value is 'N'.
									? '' // If it's 'N', set the value to an empty string.
									: 'NA';
						validateTotalPercantage(newValues);
						return {
							...prevFormData,
							[name]: newValues,
						};
					}

					const isClientGlobalRevenue = name === 'clientGlobalRevenue';
					let tempValue = isClientGlobalRevenue
						? value.split(',').join('')
						: value;
					let formattedValue = tempValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					return {
						...prevFormData,
						[name]: !isNaN(tempValue) // Check if the value is a number.
							? isClientGlobalRevenue
								? formattedValue
								: value // If it's a number, keep the value.
							: !isNaN(value.charAt(value.length - 2)) && value.length >= 2 // Check if the second-to-last character is a number and the length is at least 2.
								? prevFormData[name] // If true, retain the previous value.
								: value === 'N' // Check if the value is 'N'.
									? '' // If it's 'N', set the value to an empty string.
									: 'NA', // For all other cases, set the value to 'NA'.
					};
				} else {
					if (inputsWithOtherTextfields.includes(name)) {
						return {
							...prevFormData,
							[name]: value ? ['Other', value] : ['Other'],
						};
					}
					if (showPercentage) {
						let newValues = [...prevFormData[name]];
						let index = newValues.findIndex(item =>
							item.hasOwnProperty(selectedOption)
						);
						newValues[index][selectedOption] = value;
						validateTotalPercantage(newValues);
						return {
							...prevFormData,
							[name]: newValues,
						};
					}
					return {
						...prevFormData,
						[name]: value,
					};
				}
			}
		});
	};

	const handleSubmit = async (e, type) => {
		e.preventDefault();
		await saveOrUpdateSurveyForm({
			value: JSON.stringify(formData),
			alias_name: selectedAlias.value,
		});
		if (type === 'save') {
			showToast(
				'Your form is saved.For Submission fill all records and click on submit.',
				NotificationTypes.simple
			);
		} else {
			showToast(
				'Your form is Submitted Successfully',
				NotificationTypes.success
			);
		}
	};
	const showToast = (message, status, time = '') => {
		const newToast = {
			id: Date.now(),
			message,
			status,
		};
		if (time) {
			setToasts(prevToasts => [newToast]);
			setTimeout(() => {
				setToasts(prevToasts =>
					prevToasts.filter(toast => toast.id !== newToast.id)
				);
			}, time + 500);
		} else {
			setToasts(prevToasts => [...prevToasts, newToast]);

			setTimeout(() => {
				setToasts(prevToasts =>
					prevToasts.filter(toast => toast.id !== newToast.id)
				);
			}, toastTime + 500);
		}
	};

	const validateOtherInputFields = () => {
		let isValid = true;
		let sum = 0;
		for (let i = 0; i < formData['regionsSurveyApplicableFor'].length; i++) {
			if (formData['regionsSurveyApplicableFor'][i]) {
				let values = Object.values(formData['regionsSurveyApplicableFor'][i]);
				if (!isNaN(values[0])) {
					sum = sum + Number(values[0]);
					if (sum > 100) {
						isValid = false;
					}
				}
				if (!values[0]) {
					isValid = false;
					break;
				}
			}
		}
		if (isValid) {
			for (let i = 0; i < inputsWithOtherTextfields.length; i++) {
				if (
					formData[inputsWithOtherTextfields[i]][0] === 'Other' &&
					formData[inputsWithOtherTextfields[i]].length < 2
				) {
					isValid = false;
					break;
				}
			}
		}
		return !isValid;
	};

	const validateTotalPercantage = newValues => {
		let sum = 0;
		for (let i = 0; i < newValues.length; i++) {
			if (newValues[i]) {
				let values = Object.values(newValues[i]);
				if (!isNaN(values[0])) {
					sum = sum + Number(values[0]);
					if (sum > 100) {
						showToast(
							'The sum of the percentages in question No. 5 should be less than or equal to 100.',
							NotificationTypes.warning,
							5000
						);
					}
				}
			}
		}
	};
	if (loading) {
		return <LoadingSpinner visible={loading} message={`Loading`} />;
	}
	if (aliasList.length === 0) {
		return <NoAliasAssigned />;
	}
	return (
		<Container>
			{toasts.map(toast => (
				<Toast
					key={toast.id}
					message={toast.message}
					status={toast.status}
					time={toastTime}
				/>
			))}
			<DemoPage>
				<Navigation
					selectedAlias={selectedAlias}
					setSelectedAlias={setSelectedAlias}
					aliasList={aliasList}
				/>

				<DemoPageContent>
					<FormSection>
						<IntroSection
							id="instructions"
							name="Thank you for your participation in our Procurement Excellence RPM Survey."
							description={
								<>
									<BoldText>Instructions :</BoldText>
									<br />
									i. You can "Save" your responses under the "Confirmation"
									section and return to your in-progress survey if you are
									unable to complete<br />
									ii. You cannot "Submit" your survey until all questions have
									been populated. If details are not available for a question,
									please enter "NA" in free text field (or in the "Other" free
									text field for multiple choice questions) in order to proceed<br />
									iii. If data is not available, "NA" will be used as the
									default for any non-numeric value entered in the cell.
								</>
							}
						/>
					</FormSection>
					<FormSection>
						<IntroSection
							id={'survey-intro'}
							name="Survey Intro"
							description={`The "Survey Intro" section gathers basic information such as
							names, industry segments, and client details. It also includes
							options for regions, engagement types, and project start dates.`}
						/>
						<TextInput
							questionNo="1"
							label="Your Name"
							placeholder="Your name"
							onChange={handleChange}
							name="yourName"
							value={formData.yourName}
							required
						/>
						<TextInput
							questionNo="2"
							label="Client Name"
							placeholder="Client Name"
							onChange={handleChange}
							name="clientName"
							value={formData.clientName}
							required
						/>
						<DropdownInput
							questionNo="3"
							handleChange={handleChange}
							options={INDUSTRY_OPTIONS}
							selectedValue={formData.industry}
							label="Industry Segment" // Pass the legend text here
							name="industry"
						/>
						<NumberInput
							questionNo="4"
							label="Client's Global Revenue (USD)"
							placeholder="Client Revenue in USD"
							handleChange={handleChange}
							name="clientGlobalRevenue"
							value={formData.clientGlobalRevenue}
							required={true}
						/>
						<CheckboxInput
							legend="5. Regions Survey Applicable For" // Set the legend here
							options={REGION_OPTIONS} // Pass the options for the checkboxes
							handleChange={handleChange}
							formData={formData}
							showPercentage={true}
						/>
						<CheckboxInput
							handleChange={handleChange}
							options={NATURE_OF_ENGAGEMENT_OPTIONS}
							formData={formData}
							legend="6. Nature of Engagement"
						/>
						<RadioInput
							handleChange={handleChange}
							options={AREAS_COVERED_IN_PROJECT}
							selectedValue={formData.areasCoveredInProject}
							legendText="7. What areas are covered in your project?"
							name="areasCoveredInProject" // Pass the name prop
						/>

						<YearPicker
							questionNo="8"
							startYear={2000}
							endYear={2050}
							label={'Project Start Year'}
							value={formData.projectStartDate}
							onChange={handleChange}
							name="projectStartDate"
							required
						/>
					</FormSection>
					<FormSection>
						<IntroSection
							id="org"
							name="Org."
							description={`The "Org." section collects details on procurement staffing, reporting structure, and organizational setup, focusing on procurement and sourcing practices.`}
						/>
						<NumberInput
							questionNo="9"
							label={
								<>
									<UnderlinedText>Direct:</UnderlinedText> Total number of
									sourcing/procurement FTEs supporting strategic activities
									(e.g. Leadership, Category managers, and COE Resources)
								</>
							}
							placeholder="Number of FTEs"
							handleChange={handleChange}
							name="directTotalStrategicSourcingFTEs"
							value={formData.directTotalStrategicSourcingFTEs}
							required={true}
							instructions={
								'Please consider all Center of Excellence (CoE) resources supporting continuous improvement efforts to be strategic resources'
							}
						/>
						<NumberInput
							questionNo="10"
							label={
								<>
									<UnderlinedText>Direct:</UnderlinedText> Total number of
									sourcing/procurement FTEs supporting operational activities
									(e.g. buyers, buying desk resources, analysts, RFP and
									contract execution team members, etc.)
								</>
							}
							placeholder="Number of FTEs"
							handleChange={handleChange}
							name="directTotalBuyersOperationalProcurementFTEs"
							value={formData.directTotalBuyersOperationalProcurementFTEs}
							required={true}
							instructions={
								<>
									Please consider all Center of Excellence (CoE) resources
									supporting continuous improvement efforts to be strategic
									resources. <br /> Excluding peripheral procurement
									functions/roles, such as Master Data, Planning,
									Non-Procurement Product Development, Logistics, Accounts
									Payable, Field Engineering.
								</>
							}
						/>
						<NumberInput
							questionNo="11"
							label={
								<>
									<UnderlinedText>Indirect:</UnderlinedText> Total number of
									sourcing/procurement FTEs supporting strategic activities
									(e.g. Leadership, Category managers, and COE Resources)
								</>
							}
							placeholder="Number of FTEs"
							handleChange={handleChange}
							name="indirectTotalStrategicSourcingFTEs"
							value={formData.indirectTotalStrategicSourcingFTEs}
							required={true}
							instructions={
								'Please consider all Center of Excellence (CoE) resources supporting continuous improvement efforts to be strategic resources'
							}
						/>
						<NumberInput
							questionNo="12"
							label={
								<>
									<UnderlinedText>Indirect:</UnderlinedText> Total number of
									sourcing/procurement FTEs supporting operational activities
									(e.g. buyers, buying desk resources, analysts, RFP and
									contract execution team members, etc.)
								</>
							}
							placeholder="Number of FTEs"
							handleChange={handleChange}
							name="indirectTotalBuyersOperationalProcurementFTEs"
							value={formData.indirectTotalBuyersOperationalProcurementFTEs}
							required={true}
							instructions={
								<>
									Please consider all Center of Excellence (CoE) resources
									supporting continuous improvement efforts to be strategic
									resources.<br />Excluding peripheral procurement
									functions/roles, such as Master Data, Planning,
									Non-Procurement Product Development, Logistics, Accounts
									Payable, Field Engineering
								</>
							}
						/>
						<SliderInput
							questionNo="13"
							label="What portion sourcing and procurement FTEs are in the best-cost-country?"
							onChange={handleChange}
							name="buyersOperationalProcurementFTEsInBestCostCountry"
							value={formData.buyersOperationalProcurementFTEsInBestCostCountry}
							instructions={
								<>
									Best-cost countries are those that typically have lower labor
									costs, including India, China, Mexico, and other
									near-shore/offshore countries.<br />Excludes outsourced FTEs
									(internal resources only)
								</>
							}
						/>
						<DropdownInput
							questionNo="14"
							handleChange={handleChange}
							options={PROCUREMENT_OPTIONS}
							selectedValue={formData.procurementFunction}
							label="What function does procurement report into"
							name="procurementFunction" // Pass the name prop
						/>
						<DropdownInput
							questionNo="15"
							handleChange={handleChange}
							options={PROCUREMENT_STRUTURE_OPTIONS}
							selectedValue={formData.procurementStructure}
							label="What is procurement org's structure?"
							instructions={
								<>
									i. Centralized - Sourcing decisions and procurement activities
									are executed within a central command organization. Spending
									is leveraged centrally.<br />
									ii. Decentrilized - No formal centralized procurement or
									reporting functionality (e.g. BU specific)<br />
									iii. Center-led - A central group coordinates procurement,
									sets policy, maintains common systems and shares leading
									practices. Sourcing is leveraged across BUs where practical.<br />
									iv. Hybrid - Combination of structures across BU, geographies,
									functions, etc.
								</>
							}
							name="procurementStructure" // Pass the name prop
						/>
						<NumberInput
							questionNo="16"
							label="What is the estimated total internal labor budget for the procurement organization?"
							placeholder="Budget in USD"
							handleChange={handleChange}
							name="totalInternalLaborBudgetProcurementOrganization"
							value={formData.totalInternalLaborBudgetProcurementOrganization}
							required
						/>
						<CheckboxInput
							handleChange={handleChange}
							options={RESPONSIBILITIES_PROCUREMENT_OWN}
							formData={formData}
							legend="17. What responsibilities does procurement own?"
						/>
					</FormSection>
					<FormSection>
						<IntroSection
							id="sourcing"
							name="Sourcing"
							description={`The "Sourcing" section tracks previous savings targets, current management of indirect spend, and payment terms for materials, assessing sourcing strategies.`}
						/>
						<NumberInput
							questionNo="18"
							label={
								<>
									<UnderlinedText>Direct: </UnderlinedText> What was actual
									savings % achieved prior year (prior to AlixPartners
									engagement as a percentage of total spend)?
								</>
							}
							placeholder="Savings Target (%)"
							handleChange={handleChange}
							name="directMaterialsPreviousSavingsTarget"
							value={formData.directMaterialsPreviousSavingsTarget}
							instructions={'Includes both savings and cost avoidance'}
							required
						/>
						<NumberInput
							questionNo="19"
							label={
								<>
									<UnderlinedText>Indirect Materials:</UnderlinedText> What was
									actual savings achieved prior year (prior to AlixPartners
									engagement as a percentage of total spend)?
								</>
							}
							placeholder="Savings Target (%)"
							handleChange={handleChange}
							name="indirectMaterialsPreviousSavingsTarget"
							value={formData.indirectMaterialsPreviousSavingsTarget}
							instructions={'Includes both savings and cost avoidance'}
							required
						/>
						<SliderInput
							questionNo="20"
							label={
								'What portion of indirect spend is currently under management?'
							}
							name={'portionOfIndirectSpendUnderManagement'}
							value={formData.portionOfIndirectSpendUnderManagement}
							onChange={handleChange}
							instructions={
								'Spend under management is defined as spend that procurement is actively managing (e.g. actively sourced)'
							}
						/>
						<NumberInput
							questionNo="21"
							label="What is the weighted average/approximate payment terms (in days) for direct materials?"
							placeholder="Payment Terms (days)"
							handleChange={handleChange}
							name="averagePaymentTermsDirectMaterials"
							value={formData.averagePaymentTermsDirectMaterials}
							required
						/>
						<NumberInput
							questionNo="22"
							label="What is the weighted average/approximate payment terms (in days) for indirect materials?"
							placeholder="Payment Terms (days)"
							handleChange={handleChange}
							name="averagePaymentTermsIndirectMaterials"
							value={formData.averagePaymentTermsIndirectMaterials}
							required
						/>
					</FormSection>
					<FormSection>
						<IntroSection
							id="operational-metrics"
							name="Operational Metrics"
							description={`The "Operational Metrics" section measures the volume of purchase orders processed and the extent of PO-backed indirect spend.`}
						/>
						<NumberInput
							questionNo="23"
							label="What is the approximate # of POs processed annually (direct)?"
							placeholder="Number of POs (direct)"
							handleChange={handleChange}
							name="approximatePOsProcessedAnnuallyDirect"
							value={formData.approximatePOsProcessedAnnuallyDirect}
							required
						/>
						<NumberInput
							questionNo="24"
							label="What is the approximate # of POs processed annually (indirect)?"
							placeholder="Number of POs (indirect)"
							handleChange={handleChange}
							name="approximatePOsProcessedAnnuallyIndirect"
							value={formData.approximatePOsProcessedAnnuallyIndirect}
							required
						/>
						{/* <SliderInput
							label="23. What portion of indirect spend is PO-backed?"
							name="portionOfIndirectSpendPOBacked"
							value={formData.portionOfIndirectSpendPOBacked}
							onChange={handleChange}
						/> */}
						<SliderInput
							questionNo="25"
							label="Indirect: Approximately what portion of indirect purchase orders are touchless (i.e estimated % of total PO count generated through touchless ordering such as min/max, MRP, workflows, eCatalogs, etc. )?"
							onChange={handleChange}
							name="portionOfIndirectPurchaseOrders"
							value={formData.portionOfIndirectPurchaseOrders}
							instructions={
								'Touchless purchasing is referring to PR to PO transmission steps of the PTP process'
							}
						/>
						<SliderInput
							questionNo="26"
							label="Direct: Approximately what portion of direct purchase orders are touchless (i.e estimated % of total PO count generated through touchless ordering such as min/max, MRP, workflows, etc. )?"
							onChange={handleChange}
							name="portionOfDirectPurchaseOrders"
							value={formData.portionOfDirectPurchaseOrders}
							instructions={
								'Touchless purchasing is referring to PR to PO transmission steps of the PTP process'
							}
						/>
					</FormSection>
					<FormSection>
						<IntroSection
							id="tech-metrics"
							name="Tech. Metrics"
							description={`The "Tech. Metrics" section covers the primary technology tools used for procurement, contract management, and spend analytics.`}
						/>
						<DropdownInput
							questionNo="27"
							handleChange={handleChange}
							options={PTP_TOOL_OPTIONS}
							selectedValue={formData.ptpTool}
							label="What PTP (procure-to-pay) tool is primarily used?"
							name="ptpTool" // Pass the name prop
						/>
						<DropdownInput
							questionNo="28"
							label="What CLM (contract lifecycle management) tool is primarily used?" // Set the legend here
							options={CLM_TOOL_OPTIONS} // Pass the options for the checkboxes
							handleChange={handleChange}
							selectedValue={formData.clmTool}
							name="clmTool"
						/>
						<DropdownInput
							questionNo="29"
							handleChange={handleChange}
							options={SPEND_ANALYTICS_TOOL_OPTIONS}
							selectedValue={formData.spendAnalyticsTool}
							label="What spend analytics tool is primarily used?"
							name="spendAnalyticsTool" // Pass the name prop
						/>
						<DropdownInput
							questionNo="30"
							handleChange={handleChange}
							options={AI_OPTIONS}
							selectedValue={formData.aiValue}
							label="How would you best characterize the current state of AI incorporated across end-to-end Procurement processes?"
							name="aiValue"
						/>
					</FormSection>

					<FormSection>
						<IntroSection
							id="confirmation"
							name="Confirmation"
							description={`Please review your answers carefully before ${
								countFilledFields(formData) >= 29 ? 'saving' : 'submitting'
							} the form. Ensure that all information is correct and complete. If you are sure that all details are accurate, click the "${
								countFilledFields(formData) >= 29 ? 'Save' : 'Submit'
							}" button to finalize your ${
								countFilledFields(formData) >= 29 ? 'saving' : 'submission'
							}.`}
						/>

						<ApButtonSecondary
							onClick={e => handleSubmit(e, 'save')}
							style={{
								backgroundColor: 'black',
								color: 'white',
								border: '0px',
							}}
						>
							Save
						</ApButtonSecondary>
						<ApButtonMain
							onClick={e => handleSubmit(e, 'submit')}
							disabled={
								!(countFilledFields(formData) >= 30) ||
								validateOtherInputFields()
							}
							style={{ color: 'white', border: '0px', margin: '10px' }}
						>
							Submit
						</ApButtonMain>
					</FormSection>
				</DemoPageContent>
			</DemoPage>
		</Container>
	);
}

export default Form;
